<template>
  <section
    class="component-b3e55151"
    resmed-component-name="info_50/50_icon-line_text_image"
    v-bind:style="{ 'background-color': acf.layout['background-color'] }"
  >
    <div
      class="component"
      v-bind:class="[`text-color-${acf.layout['text-color']}`]"
    >
      <div class="container-fluid">
        <div class="row">
          <div
            class="col-12 col-md-6"
            v-bind:class="{
              'col-md-12 col-lg-6': acf.layout['single-col-md'],
              'order-2':
                acf.layout['reverse-col-order'] &&
                $root.mode !== 'xs' &&
                $root.mode !== 'sm',
            }"
          >
            <figure
              class="embed-responsive"
              v-bind:class="{
                'embed-responsive-16by9':
                  $root.mode === 'lg' ||
                  $root.mode === 'xl' ||
                  ($root.mode === 'md' && acf.layout['single-col-md']),
                'embed-responsive-4by3':
                  ($root.mode === 'md' && !acf.layout['single-col-md']) ||
                  $root.mode === 'xs' ||
                  $root.mode === 'sm',
              }"
              v-bind:style="{
                'background-image': `url(${acf.image})`,
              }"
            ></figure>
          </div>
          <div
            class="col-12 col-md-6 align-self-center"
            v-bind:class="{
              'col-md-12 col-lg-6': acf.layout['single-col-md'],
              'justify-content-end': acf.layout['reverse-col-order'],
              'order-2':
                acf.layout['single-col-md'] &&
                ($root.mode === 'xs' ||
                  $root.mode === 'sm' ||
                  $root.mode === 'md'),
            }"
          >
            <div class="wrapper">
              <eyebrow-icon
                v-if="acf.eyebrowicon"
                v-bind:eyebrowicon="acf.eyebrowicon"
              ></eyebrow-icon>
              <div class="title">
                <h5>{{ acf.name }}</h5>
              </div>
              <h2>{{ acf.headline }}</h2>
              <div v-html="acf.content"></div>

              <a
                v-if="acf.cta[0]"
                v-bind:href="acf.cta[0].cta.href"
                v-bind:target="acf.cta[0].cta.target"
                class="
                  btn
                  cta-pill
                  filled-red
                  icon
                  right-arrow
                  mt-4
                  mr-3
                  mb-3 mb-xl-0
                "
                >{{ acf.cta[0].cta.text }}</a
              >
              <a
                v-if="acf.cta[1]"
                v-bind:href="acf.cta[1].cta.href"
                v-bind:target="acf.cta[1].cta.target"
                class="ctaButton cta-pill hallow-red icon right-arrow"
                >{{ acf.cta[1].cta.text }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-b3e55151", // info_50/50_icon-line_text_image
  props: ["acf"],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-b3e55151 {
  background-color: #f4faff; // default value
}

.component {
  &.text-color-white {
    h2,
    h5,
    p {
      color: $cc-resmed-white;
    }

    h5 {
      &:before {
        background-color: $cc-resmed-white;
      }
    }
  }

  h5 {
    position: relative;
    margin-bottom: 0.5rem;

    @extend %body-normal-bold;
    @extend %eyebrow-left;
  }

  h2 {
    margin-bottom: 1rem;
  }

  [class^="col"] {
    padding: 0;

    display: flex;
    align-items: center;
    align-items: stretch;
  }

  figure {
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    height: 100%;
  }

  @media (max-width: 1199px) {
    .col-md-12 {
      .wrapper {
        max-width: none;
      }
    }
  }

  .wrapper {
    padding: 6rem 2rem;
    flex-grow: 1;

    @media (min-width: 768px) {
      max-width: 730px;
    }

    @media (min-width: 992px) {
      padding: 6rem;
    }
  }
}
</style>